var exports = {
  "r": "ActionMenu_Overlay__kkP3e6",
};

module.exports = exports;
